export const getProductCreatedTimestamp = (product) => {
    const rawDate = product?.createdAt || product?.created_at || product?.date_created || product?.creation_date;
    const explicitDate = rawDate?.$date || rawDate;
    const numericDate = Number(explicitDate);
    if (Number.isFinite(numericDate) && numericDate > 0) {
        return numericDate < 100000000000 ? numericDate * 1000 : numericDate;
    }
    const parsedDate = explicitDate ? Date.parse(explicitDate) : Number.NaN;
    if (Number.isFinite(parsedDate)) return parsedDate;
    const mongoId = String(product?._id || product?.id || '');
    return /^[a-f\d]{24}$/i.test(mongoId) ? Number.parseInt(mongoId.slice(0, 8), 16) * 1000 : 0;
};

export const compareProductCreationDescending = (left, right) =>
    getProductCreatedTimestamp(right) - getProductCreatedTimestamp(left)
    || String(right?._id || right?.id || '').localeCompare(String(left?._id || left?.id || ''));
